import DataEngine from '../../public/js/de';
import { Requestor, Replier } from '../../public/js/de.msg.request-reply';

/**
 * Helper for data engine messaging.
 */
export default class DataEngineMessaging {
  constructor(bucket, requestorId, replierId) {
    this.de = null;
    this.requestor = null;
    this.replier = null;
    this.bucket = bucket;

    this.connect(bucket, requestorId, replierId);
  }

  connect = (bucket, requestorId, replierId) => {
    this.de =
      window.location.protocol === 'https:'
        ? new DataEngine({ path: 'dataengine/', bucket })
        : new DataEngine({ host: window.location.hostname, bucket, port: 4300 });

    this.de.connection.onConnect = () => {
      this.requestor = new Requestor(this.de, requestorId, replierId, 30000);
      this.replier = new Replier(this.de, replierId);
      console.log(`Data engine request/reply connected:
      host: ${window.location.hostname}
      bucket: ${bucket}
      requestor: ${requestorId}
      replier: ${replierId}`);
    };
  };

  disconnect = () => {
    if (this.de) {
      this.de.close();
    }
  };

  sendMessage = message => this.requestor.request(message);

  onMessage = callback =>
    (this.replier.onMessage = (message, cb) => {
      callback(message, cb);
    });
}



// WEBPACK FOOTER //
// ./app/util/deMessaging.js